import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/fr/api-explorer',
    component: ComponentCreator('/fr/api-explorer', '162'),
    exact: true
  },
  {
    path: '/fr/auth',
    component: ComponentCreator('/fr/auth', '740'),
    exact: true
  },
  {
    path: '/fr/callback',
    component: ComponentCreator('/fr/callback', 'd8e'),
    exact: true
  },
  {
    path: '/fr/dashboard',
    component: ComponentCreator('/fr/dashboard', '111'),
    exact: true
  },
  {
    path: '/fr/endpoint',
    component: ComponentCreator('/fr/endpoint', '4db'),
    exact: true
  },
  {
    path: '/fr/search',
    component: ComponentCreator('/fr/search', 'd93'),
    exact: true
  },
  {
    path: '/fr/docs',
    component: ComponentCreator('/fr/docs', '9fa'),
    routes: [
      {
        path: '/fr/docs',
        component: ComponentCreator('/fr/docs', '87c'),
        routes: [
          {
            path: '/fr/docs/tags',
            component: ComponentCreator('/fr/docs/tags', 'b1a'),
            exact: true
          },
          {
            path: '/fr/docs/tags/actif',
            component: ComponentCreator('/fr/docs/tags/actif', '6e9'),
            exact: true
          },
          {
            path: '/fr/docs/tags/active',
            component: ComponentCreator('/fr/docs/tags/active', '1c5'),
            exact: true
          },
          {
            path: '/fr/docs/tags/anatomie',
            component: ComponentCreator('/fr/docs/tags/anatomie', 'd2b'),
            exact: true
          },
          {
            path: '/fr/docs/tags/api',
            component: ComponentCreator('/fr/docs/tags/api', 'ef6'),
            exact: true
          },
          {
            path: '/fr/docs/tags/appels',
            component: ComponentCreator('/fr/docs/tags/appels', '25f'),
            exact: true
          },
          {
            path: '/fr/docs/tags/application',
            component: ComponentCreator('/fr/docs/tags/application', 'b1c'),
            exact: true
          },
          {
            path: '/fr/docs/tags/authentification',
            component: ComponentCreator('/fr/docs/tags/authentification', 'a32'),
            exact: true
          },
          {
            path: '/fr/docs/tags/autorisation',
            component: ComponentCreator('/fr/docs/tags/autorisation', 'c5a'),
            exact: true
          },
          {
            path: '/fr/docs/tags/autoriser',
            component: ComponentCreator('/fr/docs/tags/autoriser', 'db5'),
            exact: true
          },
          {
            path: '/fr/docs/tags/code',
            component: ComponentCreator('/fr/docs/tags/code', 'ef3'),
            exact: true
          },
          {
            path: '/fr/docs/tags/commission',
            component: ComponentCreator('/fr/docs/tags/commission', 'e73'),
            exact: true
          },
          {
            path: '/fr/docs/tags/concept',
            component: ComponentCreator('/fr/docs/tags/concept', '457'),
            exact: true
          },
          {
            path: '/fr/docs/tags/configuration',
            component: ComponentCreator('/fr/docs/tags/configuration', 'ed1'),
            exact: true
          },
          {
            path: '/fr/docs/tags/contrats',
            component: ComponentCreator('/fr/docs/tags/contrats', 'a24'),
            exact: true
          },
          {
            path: '/fr/docs/tags/copy-trading',
            component: ComponentCreator('/fr/docs/tags/copy-trading', '6f5'),
            exact: true
          },
          {
            path: '/fr/docs/tags/country-list',
            component: ComponentCreator('/fr/docs/tags/country-list', 'e3e'),
            exact: true
          },
          {
            path: '/fr/docs/tags/creer',
            component: ComponentCreator('/fr/docs/tags/creer', 'a13'),
            exact: true
          },
          {
            path: '/fr/docs/tags/demarrage-rapide',
            component: ComponentCreator('/fr/docs/tags/demarrage-rapide', '2d5'),
            exact: true
          },
          {
            path: '/fr/docs/tags/demarrer',
            component: ComponentCreator('/fr/docs/tags/demarrer', '26d'),
            exact: true
          },
          {
            path: '/fr/docs/tags/enregistrer',
            component: ComponentCreator('/fr/docs/tags/enregistrer', 'c27'),
            exact: true
          },
          {
            path: '/fr/docs/tags/exemple',
            component: ComponentCreator('/fr/docs/tags/exemple', '71b'),
            exact: true
          },
          {
            path: '/fr/docs/tags/gagner',
            component: ComponentCreator('/fr/docs/tags/gagner', '54e'),
            exact: true
          },
          {
            path: '/fr/docs/tags/gain',
            component: ComponentCreator('/fr/docs/tags/gain', '874'),
            exact: true
          },
          {
            path: '/fr/docs/tags/garder',
            component: ComponentCreator('/fr/docs/tags/garder', 'ced'),
            exact: true
          },
          {
            path: '/fr/docs/tags/guide',
            component: ComponentCreator('/fr/docs/tags/guide', '554'),
            exact: true
          },
          {
            path: '/fr/docs/tags/historique',
            component: ComponentCreator('/fr/docs/tags/historique', '4d5'),
            exact: true
          },
          {
            path: '/fr/docs/tags/integration',
            component: ComponentCreator('/fr/docs/tags/integration', '7a1'),
            exact: true
          },
          {
            path: '/fr/docs/tags/intro',
            component: ComponentCreator('/fr/docs/tags/intro', '7f1'),
            exact: true
          },
          {
            path: '/fr/docs/tags/javascript',
            component: ComponentCreator('/fr/docs/tags/javascript', '0d4'),
            exact: true
          },
          {
            path: '/fr/docs/tags/majoration',
            component: ComponentCreator('/fr/docs/tags/majoration', 'ad1'),
            exact: true
          },
          {
            path: '/fr/docs/tags/monetisation',
            component: ComponentCreator('/fr/docs/tags/monetisation', '54a'),
            exact: true
          },
          {
            path: '/fr/docs/tags/proposition',
            component: ComponentCreator('/fr/docs/tags/proposition', '22d'),
            exact: true
          },
          {
            path: '/fr/docs/tags/site-web',
            component: ComponentCreator('/fr/docs/tags/site-web', '8df'),
            exact: true
          },
          {
            path: '/fr/docs/tags/statut',
            component: ComponentCreator('/fr/docs/tags/statut', '928'),
            exact: true
          },
          {
            path: '/fr/docs/tags/symbole',
            component: ComponentCreator('/fr/docs/tags/symbole', 'fc8'),
            exact: true
          },
          {
            path: '/fr/docs/tags/symboles',
            component: ComponentCreator('/fr/docs/tags/symboles', '9fa'),
            exact: true
          },
          {
            path: '/fr/docs/tags/ticks',
            component: ComponentCreator('/fr/docs/tags/ticks', '161'),
            exact: true
          },
          {
            path: '/fr/docs/tags/transaction',
            component: ComponentCreator('/fr/docs/tags/transaction', 'e5b'),
            exact: true
          },
          {
            path: '/fr/docs/tags/tutoriel',
            component: ComponentCreator('/fr/docs/tags/tutoriel', 'b87'),
            exact: true
          },
          {
            path: '/fr/docs/tags/websocket',
            component: ComponentCreator('/fr/docs/tags/websocket', '208'),
            exact: true
          },
          {
            path: '/fr/docs',
            component: ComponentCreator('/fr/docs', 'a0d'),
            routes: [
              {
                path: '/fr/docs/category/code-examples',
                component: ComponentCreator('/fr/docs/category/code-examples', '194'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/category/core-concepts',
                component: ComponentCreator('/fr/docs/category/core-concepts', '70e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/category/guides',
                component: ComponentCreator('/fr/docs/category/guides', '327'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/category/javascript',
                component: ComponentCreator('/fr/docs/category/javascript', 'da9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/category/javascript-examples',
                component: ComponentCreator('/fr/docs/category/javascript-examples', 'bac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/category/languages',
                component: ComponentCreator('/fr/docs/category/languages', '72f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/code-examples/javascript/active-symbols/',
                component: ComponentCreator('/fr/docs/code-examples/javascript/active-symbols/', 'fa1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/code-examples/javascript/contracts-for-symbol/',
                component: ComponentCreator('/fr/docs/code-examples/javascript/contracts-for-symbol/', 'b8d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/code-examples/javascript/keep-alive/',
                component: ComponentCreator('/fr/docs/code-examples/javascript/keep-alive/', '2e9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/code-examples/javascript/proposal/',
                component: ComponentCreator('/fr/docs/code-examples/javascript/proposal/', '1e7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/code-examples/javascript/ticks-history/',
                component: ComponentCreator('/fr/docs/code-examples/javascript/ticks-history/', '068'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/code-examples/javascript/ticks/',
                component: ComponentCreator('/fr/docs/code-examples/javascript/ticks/', '53c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/code-examples/javascript/website-status/',
                component: ComponentCreator('/fr/docs/code-examples/javascript/website-status/', '0b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/core-concepts/api-calls-anatomy/',
                component: ComponentCreator('/fr/docs/core-concepts/api-calls-anatomy/', '2b1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/core-concepts/authorization-authentication/',
                component: ComponentCreator('/fr/docs/core-concepts/authorization-authentication/', 'e5b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/core-concepts/copytrading/',
                component: ComponentCreator('/fr/docs/core-concepts/copytrading/', '437'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/core-concepts/websocket/',
                component: ComponentCreator('/fr/docs/core-concepts/websocket/', 'a08'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/guides/about-the-deriv-api/',
                component: ComponentCreator('/fr/docs/guides/about-the-deriv-api/', 'fec'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/guides/monetizing-the-deriv-api/',
                component: ComponentCreator('/fr/docs/guides/monetizing-the-deriv-api/', '929'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/guides/oauth2/',
                component: ComponentCreator('/fr/docs/guides/oauth2/', '131'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/intro',
                component: ComponentCreator('/fr/docs/intro', '644'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/languages/intro',
                component: ComponentCreator('/fr/docs/languages/intro', '200'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/languages/javascript/get-country-list/',
                component: ComponentCreator('/fr/docs/languages/javascript/get-country-list/', 'b40'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/languages/javascript/project-setup/',
                component: ComponentCreator('/fr/docs/languages/javascript/project-setup/', 'f92'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/languages/javascript/websocket-connection/',
                component: ComponentCreator('/fr/docs/languages/javascript/websocket-connection/', '3c4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/fr/docs/setting-up-a-deriv-application',
                component: ComponentCreator('/fr/docs/setting-up-a-deriv-application', '337'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/fr/',
    component: ComponentCreator('/fr/', '663'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
